import React from 'react';
import HeroSection from '../../components/organisms/HeroSection/HeroSection';
import Features from '../../components/organisms/Features/Features';
import CategoryGrid from '../../components/organisms/CategoryGrid/CategoryGrid';
import ProductGrid from '../../components/organisms/ProductGrid/ProductGrid';
import AIRecommendations from '../../components/organisms/AIRecommendations/AIRecommendations';
import PromoBanner from '../../components/organisms/PromoBanner/PromoBanner';
import Testimonials from '../../components/organisms/Testimonials/Testimonials';
import Newsletter from '../../components/organisms/Newsletter/Newsletter';
import PWAInstallPrompt from '../../components/molecules/PWAInstallPrompt/PWAInstallPrompt';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <Features />
      <CategoryGrid />
      <ProductGrid />
      <AIRecommendations />
      <PromoBanner />
      <Testimonials />
      <Newsletter />
      <PWAInstallPrompt />
    </div>
  );
};

export default Home;
